const unsupportedNetworksLower = [
  'webgains-x'
]

export function isUnsupportedNetwork(networkName: string): boolean {
  return unsupportedNetworksLower.includes(networkName && networkName.toLowerCase() || '')
}
